import { editEmployeeBulkSession } from "../../infrastructure/repository/employees-repository";
import { findCompanyId } from "../../infrastructure/repository/company-repository";

export async function sendEmployeeBulkSession(employeeIds) {
  const companyId = await findCompanyId();
  await editEmployeeBulkSession({ companyId, employeeIds });
}
